// extracted by mini-css-extract-plugin
export var footer = "_os-0";
export var inherit = "_os-1";
export var input = "_os-2";
export var modalContent = "_os-3";
export var quillEditor = "_os-4";
export var subtitle = "_os-5";